import { useMapsLibrary } from '@vis.gl/react-google-maps'
import { useEffect } from 'react'

/**
 * When the user clicks "Use current location", reverse geocode their
 * coordinates and show the estimated zip code in the address field.
 * If no zip code is found, the field stays empty.
 */
export function useUserLocationZip(searchStore) {
  const geocodingLibrary = useMapsLibrary('geocoding')
  const { potentialUserLocation, userLocationZipRequested } = searchStore

  useEffect(() => {
    if (
      !geocodingLibrary ||
      !userLocationZipRequested ||
      !potentialUserLocation
    )
      return

    searchStore.setUserLocationZipRequested(false)
    const { lat, lng } = potentialUserLocation
    new geocodingLibrary.Geocoder()
      .geocode({ location: { lat, lng } })
      .then(({ results }) => {
        const zip = results?.[0]?.address_components?.find(component =>
          component.types.includes('postal_code')
        )?.short_name
        // Don't overwrite anything the user typed while the lookup ran
        if (zip && !searchStore.autocompleteInputValue) {
          searchStore.setAutocompleteInputValue(zip)
        }
      })
      .catch(() => {})
  }, [
    geocodingLibrary,
    potentialUserLocation,
    userLocationZipRequested,
    searchStore,
  ])
}
